// Remove the open class when clicking outside
document.addEventListener('click', () => {
    document.querySelectorAll('.desired-route-notification').forEach(wrapper => {
        wrapper.classList.remove('open');
    });
});

// Select2 with dynamic options fetching
jQuery(document).ready(function($) {
    const fromSelect = $('#desired-route-from');
    const toSelect = $('#desired-route-to');

    // Check if a pre-selected option exists for "from" and "to" from PHP GET
    const preSelectedFrom = fromSelect.find('option[selected]').val();
    const preSelectedTo = toSelect.find('option[selected]').val();

    // Add an empty option at the start if no pre-selected option exists
    if (!preSelectedFrom) {
        fromSelect.append(new Option('Select a destination', ''));
    }
    if (!preSelectedTo) {
        toSelect.append(new Option('Select a destination', ''));
    }

    // Store initial data for resetting
    let initialData = {};

    // Fetch destinations for the "from" and "to" select fields
    fetch(`${apiBaseUrl}/api/transfer/destinations`)
        .then(response => response.json())
        .then(data => {
            initialData = data; // Store the initial data
            // Clear existing options
            fromSelect.empty();
            toSelect.empty();

            // Add an empty option at the start
            fromSelect.append(new Option('Select a destination', ''));
            toSelect.append(new Option('Select a destination', ''));

            // Iterate over the data object
            for (const [key, value] of Object.entries(data)) {
                if (key.startsWith('airport-') || key.startsWith('resort-')) {
                    const optionFrom = new Option(value, key);
                    const optionTo = new Option(value, key);
                    $(optionFrom).attr('lmf-from-value', value);
                    $(optionTo).attr('lmf-to-value', value);
                    fromSelect.append(optionFrom);
                    toSelect.append(optionTo);
                }
            }

            // Set the pre-selected option if it exists
            if (preSelectedFrom) {
                fromSelect.val(preSelectedFrom).trigger('change');
            }
            if (preSelectedTo) {
                toSelect.val(preSelectedTo).trigger('change');
            }
        })
        .catch(error => console.error('Error fetching destinations:', error));

    // Initialize Select2 for "to" select
    toSelect.select2({
        placeholder: "Select a destination",
        allowClear: true
    }).on('select2:open', function() {
        // Fix for iOS double-tap issue
        $('.select2-results__options')
            .off('touchstart')
            .on('touchstart', 'li', function(e) {
                e.stopPropagation();
            });
    });

    // Add iOS touch event handlers for "to" select
    toSelect.next('.select2-container')
        .off('touchstart')
        .on('touchstart', function(e) {
            e.stopPropagation();
        });

    // Update "to" select options based on "from" selection
    fromSelect.on('change', function() {
        if (!fromSelect.val()) {
            fromSelect.css('border', '2px solid red');
            // Reset "to" select to initial options
            toSelect.empty();
            toSelect.append(new Option('Select a destination', ''));
            for (const [key, value] of Object.entries(initialData)) {
                if (key.startsWith('airport-') || key.startsWith('resort-')) {
                    const optionTo = new Option(value, key);
                    $(optionTo).attr('lmf-to-value', value);
                    toSelect.append(optionTo);
                }
            }
        } else {
            fromSelect.css('border', '');
            updateToSelectOptions(fromSelect.val());
        }
    });

    function updateToSelectOptions(routeCode) {
        fetch(`${apiBaseUrl}/api/transfer/destinations?route_code=${routeCode}`)
            .then(response => response.json())
            .then(data => {
                toSelect.empty(); // Clear existing options
                toSelect.append(new Option('Select a destination', '')); // Add empty option

                for (const [key, value] of Object.entries(data)) {
                    if (key !== "0" && key !== "1" && key !== "2" && key !== "8" && key !== "9") {
                        toSelect.append(new Option(value, key));
                    }
                }

                // Set the pre-selected option if it exists
                if (preSelectedTo) {
                    toSelect.val(preSelectedTo).trigger('change');
                }

                // Reinitialize Select2 to update options
                toSelect.trigger('change.select2');
            })
            .catch(error => console.error('Error fetching to destinations:', error));
    }

    // Initialize Select2 for filter dropdowns
    $('#desired-route-from, #desired-route-to').select2({
        placeholder: "Airport, City or Resort",
        allowClear: true
    }).on('select2:open', function() {
        // Add custom classes to the select2 container when opened
        $('.select2-container--open').addClass('desired-route-notification-select2-class');
        
        // Fix for iOS double-tap issue
        $('.select2-results__options')
            .off('touchstart')
            .on('touchstart', 'li', function(e) {
                e.stopPropagation();
            });

        // Focus the search field
        setTimeout(function() {
            $('.select2-search__field').focus();
        }, 100);
    });

    // Add iOS touch event handlers
    $('.select2-container')
        .off('touchstart')
        .on('touchstart', function(e) {
            e.stopPropagation();
        });
});

jQuery(document).ready(function($) {
    $('.notification-form').on('submit', function(e) {
        e.preventDefault(); // Prevent the default form submission

        // Collect form data
        const email = $('#desired-route-notification-email').val();
        const from = $('#desired-route-from').val();
        const to = $('#desired-route-to').val();
        const date = $('#desired-route-notification-date').val();
        const pax = 1; // Assuming 1 passenger as the form does not have a field for passengers

        const checkbox = $('#desired-route-notification-checkbox').is(':checked');

        if (checkbox && email) {
            // Prepare data for the newsletter subscription
            const newsletterData = {
                'SubscriptionForm[email]': email
            };

            // Make an AJAX request to subscribe to the newsletter
            $.ajax({
                url: 'https://booking.alps2alps.com/en/loyalty/subscribe-to-newsletter',
                method: 'POST',
                data: newsletterData,
                success: function(response) {
                    if (response.success === 1) {
                        console.log('Newsletter subscription successful:', response);
                        dataLayer.push({
                            'event': 'email_submitted',
                            'value': 'desired route + newsletter'
                        });
                    } else {
                        console.error('Newsletter subscription failed:', response);
                     
                    }
                },
                error: function(error) {
                    console.error('Error during newsletter subscription:', error);
                   
                }
            });
        }

        // Prepare data for the API request
        const requestData = {
            "TransferOfferSubscriber": {
                "email": email,
                "dest_code_from": from,
                "dest_code_to": to,
                "date": date,
                "pax": pax
            }
        };

        // Make the API request
        fetch(`${apiBaseUrl}/api/offer/subscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
        .then(response => {
            if (response.ok) {
                dataLayer.push({
                    'event': 'email_submitted',
                    'value': 'desired route'
                });
                return response.json();
            } else {
                throw new Error('Failed to subscribe');
            }
        })
        .then(data => {
            console.log('Subscription successful:', data);
            alert('Subscription successful!');
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Subscription failed. Please try again.');
        });
    });
});
